import React, { ReactNode } from "react";
import { Col, Collapse, CollapseProps, Row } from "antd";
import { ArrowDownIcon, ArrowUpIcon } from "../icons";
import { BemHelper } from "../utils/BemHelper";
import classNames from "classnames";

const { Panel } = Collapse;

type Props = {
  title: ReactNode;
  opened?: boolean;
  children: React.ReactNode;
  bottomActions?: ReactNode;
  isInvalid?: boolean;
};

const bem = new BemHelper("collapsible-panel");

export const CollapsiblePanel: React.FC<Props & CollapseProps> = ({
  title,
  children,
  opened = false,
  bottomActions,
  isInvalid,
  ...props
}) => {
  return (
    <Collapse
      defaultActiveKey={opened ? ["1"] : ["2"]}
      expandIconPosition='end'
      className={classNames(bem.block(), isInvalid && bem.modifier("is-invalid"))}
      expandIcon={({ isActive }) => (!isActive ? <ArrowDownIcon /> : <ArrowUpIcon />)}
      {...props}
    >
      <Panel
        header={
          <>
            <span>{title}</span>
            {/* {isInvalid && (
              <span className={classNames(bem.element("header-additional-text"))}>
                required field
              </span>
            )} */}
          </>
        }
        key='1'
        forceRender
      >
        {children}
        {bottomActions && (
          <Row justify='end'>
            <Col>{bottomActions}</Col>
          </Row>
        )}
      </Panel>
    </Collapse>
  );
};
